import { SegmentedControl } from "@mantine/core";
import {
  useSystemEmailModeOptions,
  useSystemEmailModeSelection,
} from "../../../hooks/admin/useSystemEmailModeSelection";
import {
  SystemEmailMode,
  SystemEmailRegistryEntry,
} from "../../../services/admin/systemEmails.service";

interface Props {
  entry: SystemEmailRegistryEntry;
  disabled: boolean;
  onOpen: (mode: SystemEmailMode) => void;
  onReset: () => void;
}

export function SystemEmailModeSelector({
  entry,
  disabled,
  onOpen,
  onReset,
}: Props) {
  const options = useSystemEmailModeOptions(entry.holdable);
  const handleChange = useSystemEmailModeSelection(entry, onOpen, onReset);
  return (
    <SegmentedControl
      data={options}
      disabled={disabled}
      onChange={handleChange}
      value={entry.mode}
    />
  );
}
